// extracted by mini-css-extract-plugin
export default {"promo":"PromoBadge-module-promo","logo":"PromoBadge-module-logo","external":"PromoBadge-module-external","externalLabel":"PromoBadge-module-externalLabel"};